// The binding-handler was designed to only fire attached click events if another element
//   using the clickOnce binding-handler (with the same specified namespace) has not yet
//   already been fired.
//
//  Usage:
//
//
//  Example 1 (default namespace):
//
//    <div data-bind="clickOnce: parentFn">
//        <div data-bind="clickOnce: childFn">
//        </div>
//    </div>
//
//    When the element attached to the `childFn` function is clicked, `childFn` will execute,
//      but the parent's `parentFn` function will not be fired.
//
//
//  Example 2 (specified namespace):
//
//    <div data-bind="clickOnce: parentFn">
//        <div data-bind="
//            clickOnce: {
//                namespace: 'foo',
//                click: fooFn
//            }
//        ">
//            <div data-bind="clickOnce: child1Fn">
//            </div>
//            <div data-bind="
//                clickOnce: {
//                    namespace: 'foo',
//                    click: child2Fn
//                }
//            ">
//            </div>
//        </div>
//    </div>
//
//    When the element attached to the `fooFn` function is clicked, both `fooFn` and `parentFn`
//      will fire because they do not share a namespace.  When the element attached to `child1Fn`
//      is clicked, only `child1Fn` and `fooFn` will be fired but NOT `parentFn`.  This is because
//      both `child1Fn` and `parentFn` elements share the same namespace (none specified so the
//      default).  When the element attached to `child2Fn` is clicked, however, only `child2Fn` and
//      `parentFn` will be fired but NOT `fooFn`.  This is because both `child2Fn` and `fooFn`
//      elements share the same namespace ('foo').
//
//
//  Example 3 (multiple specified namespaces):
//
//    <div data-bind="
//        clickOnce: {
//            namespace: 'root',
//            click: parentFn
//        }
//    ">
//        <div data-bind="
//            clickOnce: {
//                namespace: 'foo',
//                click: fooFn
//            }
//        ">
//            <div data-bind="
//                clickOnce: {
//                    namespace: ['root', 'foo'],
//                    click: child1Fn
//                }
//            ">
//            </div>
//       </div>
//    </div>
//
//    When the element attached to the `child1Fn` function is clicked, neither `fooFn` nor `parentFn`
//      will fire because there are multiple namespaces specified on the element attached to `child1Fn`.
//
define('bindingHandlers/clickOnce',[
    'lib/knockout',
    'lib/lodash4'
], function (
    ko,
    _
) {
    'use strict';

    var DEFAULT_NAMESPACE = "default";
    var NAMESPACE_PREFIX = "_clickOnce_";

    ko.bindingHandlers.clickOnce = {

        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

            var accessedValue = ko.unwrap(valueAccessor());

            var clickFn = function () {};
            var namespace = DEFAULT_NAMESPACE;

            // handle function type value accessor (otherwise object is assumed)
            if (typeof accessedValue === 'function') {
                clickFn = accessedValue;
            }
            else if (typeof accessedValue === 'string' || _.isArray(accessedValue)) {
                namespace = accessedValue;
            }
            else {
                clickFn = ko.unwrap(accessedValue.click) || clickFn;
                namespace = ko.unwrap(accessedValue.namespace) || DEFAULT_NAMESPACE;
            }

            // ensure namespaces is an array of strings
            var namespaces = namespace;
            if (typeof namespace === 'string') {
                namespaces = [namespace];
            }

            var wrappedClickFn = function (data, ev) {

                // if jquery event detected use that, otherwise use native event
                ev = ev.originalEvent || ev;

                // if event is tagged previously by any of the provided namespaces, then do
                //   not trigger click function
                var eventHasBeenHandledByNamespace = _.some(namespaces, function (ns) {
                    return ev[NAMESPACE_PREFIX + ns];
                });
                if(eventHasBeenHandledByNamespace)
                {
                    return true; // Do not stop default behavior
                }

                // tag event with provided namespaces
                _.each(namespaces, function (ns) {
                    ev[NAMESPACE_PREFIX + ns] = true;
                });

                // fire the provided click function
                clickFn(data, ev);

                return true; // Do not stop default behavior
            };

            var newValueAccessor = function () {
                var result = {};
                result.click = wrappedClickFn;
                return result;
            };

            // Pass to bindingHandler event
            return ko.bindingHandlers.event.init.call(
                this,
                element,
                newValueAccessor,
                allBindings,
                viewModel,
                bindingContext
            );
        }
    };

    return ko.bindingHandlers.clickOnce;

});

